import { HTMLSpocUIProps, Orientation, PropGetter } from "@/types";
import { Ref, useCallback, useMemo } from "react";
import { radiogroupClasses, RadioGroupVariantProps } from "./RadioGroup.style";
import { RadioGroup as BaseRadioGroup } from "@base-ui-components/react/radio-group";
interface Props extends HTMLSpocUIProps<"div", "onChange"> {
  /**
   * Ref to the DOM node.
   */
  ref?: Ref<HTMLElement> | undefined;
  /**
   * The orientation of the separator.
   * @default 'horizontal'
   */
  orientation?: Orientation;

  /**
   * The label for radio group as div.
   * @default undefined
   */
  label?: string;
  onChange?: (value: unknown, event: Event) => void;
}

export type UseRadioGroupProps = Props &
  RadioGroupVariantProps &
  Omit<BaseRadioGroup.Props, "className" | "onChange"> & {
    variantOptionLabel?: "alphabet" | "number";
  };

export const useRadioGroup = (props: UseRadioGroupProps) => {
  const {
    className,
    orientation = "horizontal",
    variant,
    ...otherProps
  } = props;

  const styles = useMemo(
    () =>
      radiogroupClasses({
        orientation: variant === "options" ? "vertical" : orientation,
        variant,
        className,
      }),
    [orientation, className, variant]
  );

  //@ts-ignore
  const getRadioGroupProps: PropGetter = useCallback(
    (props = {}) => ({
      className: styles,
      role: "radiogroup",
      "data-orientation": orientation,
      ...otherProps,
      ...props,
    }),
    [styles, orientation, otherProps]
  );
  return { variant, getRadioGroupProps };
};

export type UseRadioGroupReturn = ReturnType<typeof useRadioGroup>;
